export default __webpack_public_path__ + "static/media/toyota.010e0af2.png";